import * as React from 'react'
function SvgSend(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M35.414 5.586a2 2 0 00-2.086-.468l-28 10a1.997 1.997 0 00-.222 3.67l9.172 4.584L26 15l-8.374 11.724 4.584 9.172a2.007 2.007 0 001.912 1.1 2 2 0 001.764-1.324l10-28a2.005 2.005 0 00-.472-2.086z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgSend
